import Label from '@cinch/oxd-components/label/src'
import cx from 'classnames'
import React from 'react'

import { FieldRenderProps } from 'react-final-form'

import * as styles from './button-group.module.css'

interface ButtonGroup extends FieldRenderProps {
  label?: string
  options?: Array<{
    children: React.ReactNode | React.ReactNodeArray
    value: string | number
    disabled?: boolean
  }>
  onReselect?: () => any
}

const ButtonGroup: React.FC<ButtonGroup> = ({ options = [], onReselect, input, meta, label }) => {
  const onClick = (event: any) => {
    // todo: this should be refactored not to rely on dataset dom attr, as these get re-rendered when date changes !!!
    // refactor to use inline radio field
    const value = event.target.dataset.value
    if (value === input.value && !!onReselect) {
      onReselect()
    } else {
      input.onChange(value)
    }
  }

  return (
    <div data-field={input.name}>
      {label && <Label inputId={input.name}>{label}</Label>}
      <div className={styles.buttonGroup}>
        {options.map(({ children, value, disabled }) => (
          <button
            type="button"
            className={cx(styles.button, {
              [styles.active]: value.toString() === input.value,
              [styles.valid]: meta.valid,
              [styles.invalid]: meta.invalid,
            })}
            onClick={onClick}
            data-value={value}
            disabled={disabled}
            key={value}
          >
            {children}
          </button>
        ))}
      </div>
    </div>
  )
}

export default ButtonGroup
